var React = require('react');

function DifficultyLevelBlackPill (props) {
    return React.createElement("svg",props,React.createElement("g",{"data-name":"Layer 2"},React.createElement("g",{"data-name":"Layer 1"},React.createElement("g",{"data-name":"Artwork 13"},[React.createElement("rect",{"fill":"#E7993B","width":"132","height":"67.35","rx":"32.31","key":0}),React.createElement("polygon",{"fill":"#000 ","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"2","points":"90.77 33.85 65.84 61.73 40.92 33.85 65.84 5.97 90.77 33.85","key":1})]))));
}

DifficultyLevelBlackPill.defaultProps = {"role":"presentation","viewBox":"0 0 132 67.35"};

module.exports = DifficultyLevelBlackPill;

DifficultyLevelBlackPill.default = DifficultyLevelBlackPill;
